import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchMeetingsList = createAsyncThunk("fetchMeetingsList", async ({ page, limit, filters }) => {
	const token = localStorage.getItem("auth_token");

	const isAttendee = filters?.isAttendee != null ? filters?.isAttendee : true;

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`meeting/list/all?page=${page}&limit=${limit}&isAttendee=${isAttendee}`, config);

	return response.data.data;
});

const MeetingsListSlice = createSlice({
	name: "MeetingsListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchMeetingsList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchMeetingsList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.page;
			state.total = action.payload.total;
		});
		builder.addCase(fetchMeetingsList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default MeetingsListSlice.reducer;
